import type { ErrorComponentProps } from "@tanstack/solid-router";
import { ErrorComponent, Link, rootRouteId, useMatch, useRouter } from "@tanstack/solid-router";
import type { VoidComponent } from "solid-js";

const DefaultCatchBoundary: VoidComponent<ErrorComponentProps> = (props) => {
	const router = useRouter();
	const isRoot = useMatch({ strict: false, select: (state) => state.id === rootRouteId });

	console.error("DefaultCatchBoundary Error:", props.error);

	return (
		<div class="flex min-w-0 flex-1 flex-col items-center justify-center gap-6 p-4">
			<ErrorComponent error={props.error} />

			<div class="flex flex-wrap items-center gap-2">
				<button
					onClick={() => {
						router.invalidate().catch(console.error);
					}}
					class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}
				>
					Try Again
				</button>

				{isRoot() ? (
					<Link
						to="/"
						class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}
					>
						Home
					</Link>
				) : (
					<Link
						to="/"
						class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}
						onClick={(event) => {
							event.preventDefault();
							globalThis.history.back();
						}}
					>
						Go Back
					</Link>
				)}
			</div>
		</div>
	);
};

export { DefaultCatchBoundary };
